import warningIcon from "../../assets/images/notifications/icon-circle-exclamation.svg";
import infoIcon from "../../assets/images/notifications/icon-circle-info.svg";
import successIcon from "../../assets/images/notifications/icon-smiley.svg";
import infoImg from "../../assets/images/info-icon-new.svg";
interface propsTypes {
  type: "error" | "success" | "info" | "warning";
}
const ToastCustonIcon = ({ type }: propsTypes) => {
  return (
    <>
      {type === "error" && (
        <img alt="error" className="toastWarning" src={warningIcon} />
      )}
      {type === "success" && <img alt="success" src={successIcon} />}
      {type === "info" && <img alt="info" src={infoIcon} />}
      {type === "warning" && <img alt="info" src={infoImg} />}
    </>
  );
};

export default ToastCustonIcon;
